/** * * Asynchronously loads the component for
UpgradePlan
* */ import { lazyLoad } from "utils/loadable";
export const UpgradePlan = lazyLoad(
  () => import("./index"),
  (module) => module.UpgradePlan
);
